<template>
  <div class="make-seal-wrap" v-loading="loading">
    <div class="inner">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="rule-form"
        label-width="115px"
        label-position="left"
      >
        <div v-if="updateMode == 0">
          <div class="form-label">印章样式</div>

          <el-form-item label prop="sealType">
            <ul class="seal-style-list">
              <li class="seal-style-item" @click="setSealType(0)">
                <div
                  class="img-wrap"
                  :class="ruleForm.sealType === 0 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/sealImg3.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.sealType" :label="0"
                    >公章</el-radio
                  >
                </div>
              </li>

              <li class="seal-style-item" @click="setSealType(1)">
                <div
                  class="img-wrap"
                  :class="ruleForm.sealType === 1 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/sealImg2.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.sealType" :label="1"
                    >专用章-带五角星</el-radio
                  >
                </div>
              </li>

              <li class="seal-style-item" @click="setSealType(2)">
                <div
                  class="img-wrap"
                  :class="ruleForm.sealType === 2 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/sealImg1.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.sealType" :label="2"
                    >专用章-不带五角星</el-radio
                  >
                </div>
              </li>

              <li class="seal-style-item" @click="setSealType(4)">
                <div
                  class="img-wrap"
                  :class="ruleForm.sealType === 4 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/ellipse_seal.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.sealType" :label="4"
                    >椭圆章</el-radio
                  >
                </div>
              </li>
            </ul>
          </el-form-item>
          <div class="form-label sealPrePosition">
            印章规格

            <div class="seal-preview">
              <div class="seal-pre-img">
                <div class="title">印章预览</div>

                <div class="img-wrap">
                  <template v-if="sealImg">
                    <img
                      :style="{ transform: 'scale(0.5)' }"
                      :src="sealImg"
                      alt
                    />
                  </template>

                  <template v-else-if="ruleForm.sealUrl">
                    <img :src="ruleForm.sealUrl" alt />
                  </template>

                  <template v-else>
                    <img
                      v-if="ruleForm.sealType === 4"
                      src="@/assets/imgs/ellipse_seal.png"
                      alt
                    />
                    <img
                      class="example"
                      v-else
                      src="@/assets/imgs/sealImg2.png"
                      alt
                    />
                  </template>
                </div>
              </div>

              <el-button type="primary" @click="getSealImg">预览</el-button>
              <el-button @click="handleDownloadSeal">下载</el-button>
            </div>
          </div>
          <el-form-item
            label="印章直径"
            prop="diametre"
            v-if="ruleForm.sealType !== 4"
          >
            <el-select
              v-model="ruleForm.diametre"
              placeholder="印章直径"
              style="width: 320px"
            >
              <el-option
                v-for="item in diametreOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="圆边宽" prop="siding">
            <el-input
              v-model="ruleForm.siding"
              placeholder="圆边宽"
              style="width: 320px"
              disabled
            ></el-input>
          </el-form-item>
          <div class="form-label">印章文字</div>

          <el-form-item label="环绕文字" prop="comName" class="form-content">
            <el-input
              class="seal-text"
              v-model="companyName"
              placeholder="公司名称"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="添加分公司" v-if="ruleForm.sealType === 0">
            <el-input
              v-model="ruleForm.surroundWord"
              :maxlength="30 - companyName.length"
              placeholder="请输入分公司名称(非必填)"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="中间横排文字" v-if="ruleForm.sealType === 4">
            <el-input
              v-model="ruleForm.centerWord"
              maxlength="20"
              placeholder="请输入中间横排文字(非必填)"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="下方横排文字">
            <el-input
              v-model="ruleForm.rankWord"
              maxlength="8"
              placeholder="请输入下方横排文字(非必填)"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="信息编码"
            prop="infoCode"
            v-if="ruleForm.sealType !== 4"
          >
            <el-input
              v-model="ruleForm.infoCode"
              maxlength="15"
              placeholder="请输入印章上13-15位数字/字母(非必填)"
              style="width: 320px"
            ></el-input>
          </el-form-item>
        </div>

        <div v-else>
          <div class="form-label">印章样式</div>

          <el-form-item label prop="uploadSealType">
            <ul class="seal-style-list">
              <li class="seal-style-item" @click="setUploadSealType(0)">
                <div
                  class="img-wrap"
                  :class="ruleForm.uploadSealType === 0 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/sealImg3.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.uploadSealType" :label="0"
                    >公章</el-radio
                  >
                </div>
              </li>

              <li class="seal-style-item" @click="setUploadSealType(1)">
                <div
                  class="img-wrap"
                  :class="ruleForm.uploadSealType === 1 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/sealImg2.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.uploadSealType" :label="1"
                    >专用章-带五角星</el-radio
                  >
                </div>
              </li>

              <li class="seal-style-item" @click="setUploadSealType(2)">
                <div
                  class="img-wrap"
                  :class="ruleForm.uploadSealType === 2 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/sealImg1.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.uploadSealType" :label="2"
                    >专用章-不带五角星</el-radio
                  >
                </div>
              </li>

              <li class="seal-style-item" @click="setUploadSealType(4)">
                <div
                  class="img-wrap"
                  :class="ruleForm.uploadSealType === 4 ? 'select' : ''"
                >
                  <img src="@/assets/imgs/ellipse_seal.png" alt />
                </div>

                <div class="radio-wrap">
                  <el-radio v-model="ruleForm.uploadSealType" :label="4"
                    >椭圆章</el-radio
                  >
                </div>
              </li>
            </ul>
          </el-form-item>
          <div class="form-label sealPrePosition">
            印章规格
          </div>
          <el-form-item
            label="印章直径"
            prop="diametre"
            v-if="ruleForm.uploadSealType !== 4"
          >
            <el-select
              v-model="ruleForm.uploadDiametre"
              placeholder="印章直径"
              style="width: 320px"
              @change="handleOption"
            >
              <el-option
                v-for="item in diametreOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="圆边宽" prop="siding">
            <el-input
              v-model="ruleForm.siding"
              placeholder="圆边宽"
              style="width: 320px"
              disabled
            ></el-input>
          </el-form-item>
          <div
            v-if="ruleForm.uploadSealUrl && !imageUrl"
            class="item-update item-update-status"
          >
            <div class="seal-img-box">
              <img class="seal-img" :src="ruleForm.uploadSealUrl" alt="" />
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import makeSeal from '@/utils/makeSealNew'
  import { drawEllipseSeal } from '@/lib/drawEllipseSeal'
  import FXQ from '@/lib/drawSeal'

  export default {
    components: {},

    data() {
      const checkAge = (rule, value, callback) => {
        if (!value) {
          return callback()
        }

        if (!/^[\da-zA-Z]+$/g.test(value)) {
          return callback(new Error('请输入数字或字母'))
        }

        if (value.length < 13) {
          return callback(new Error('公章为13-15位'))
        }

        callback()
      }

      return {
        id: undefined,
        // 重定向地址，用于在添加印章后重回原页面
        redirectUrl: undefined,
        imageUrl: '',
        loading: false,
        signLoading: false,

        sealImg: null,

        updateMode: '0', // 0在线制章1本地制章

        companyName: '',

        ruleForm: {
          sealName: '',
          // 印章样式0-企、事业公章 1-专用章-带五角星 2-专用章-不带五角星 3-共青团 4-椭圆章
          sealType: 0,
          // 本地上传印章样式
          uploadSealType: undefined,
          // 在线制章印章直径0-38mm 1-40mm 2-42mm 3-58mm
          diametre: 2,
          // 本地上传印章
          uploadDiametre: 2,

          siding: '1.2mm',

          surroundWord: '',
          // 中间横排文字
          centerWord: '',

          rankWord: '',

          infoCode: null,

          // userIdList: [],

          sealOwnerList: [],

          sealUrl: null,

          // 签章状态 0:待审核 1:审核拒绝 2:审核通过
          sealStatus: 3,
        },

        sealWidth: [3.8, 4.0, 4.2, 5.8],

        diametreOptions: [
          {
            value: 0,

            label: '38mm',
          },

          {
            value: 1,

            label: '40mm',
          },

          {
            value: 2,

            label: '42mm',
          },

          // {
          //   value: 3,

          //   label: '58mm',
          // },
        ],

        rules: {
          sealName: [
            {
              required: true,

              message: '请输入印章名称',

              trigger: 'change',
            },

            { max: 10, message: '长度在10个字符以内', trigger: 'change' },
          ],

          infoCode: [
            {
              validator: checkAge,

              trigger: 'change',
            },
          ],
        },
        cropperOption: {},
        imgSlice: '',
      }
    },

    computed: {
      userIdList() {
        return this.ruleForm.sealOwnerList.map(e => e.sealUserId)
      },
      sealStatus() {
        // // 签章状态 0:待审核 1:审核拒绝 2:审核通过
        return this.ruleForm.sealStatus
      },
    },

    async created() {
      const { id, redirectUrl } = this.$route.query
    },

    mounted() {
      // this.getSealImg()
    },

    methods: {
      imgLoad() {
        this.handleSlider(0)
      },
      handleSlider(val) {
        this.signLoading = true
        const img = document.querySelector('.cropper-view-box > img')
        const canvasImg = document.querySelector('.cropper-box-canvas>img')
        setTimeout(() => {
          this.removeImgBg(img, canvasImg, val)
        }, 200)
      },
      handleImgLarge(val) {
        this.$refs.cropper.changeScale(val)
      },
      rotateLeft() {
        this.$refs.cropper.rotateLeft()
      },
      validateImg(value) {
        return ['jpg', 'jpeg', 'png'].indexOf(value) === -1
      },
      handleSwitch(val) {
        this.updateMode = val

        if (val === '1' && this.ruleForm.uploadSealType == null) {
          this.ruleForm.uploadSealType = 0
        }
      },

      gray(src, cb) {
        const canvas = document.createElement('canvas')

        const ctx = canvas.getContext('2d')

        const invalidImgD = document.querySelector('#invalidImg')

        const img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = src

        img.onload = () => {
          canvas.height = img.height

          canvas.width = img.width

          ctx.drawImage(img, 0, 0)

          ctx.drawImage(
            invalidImgD,

            canvas.width / 2 - 90 / 2,

            canvas.height / 2 - 60 / 2,

            90,

            60
          )

          const imgdata = ctx.getImageData(0, 0, canvas.width, canvas.height)

          const { data } = imgdata

          /* 灰度处理：求r，g，b的均值，并赋回给r，g，b */

          for (let i = 0, n = data.length; i < n; i += 4) {
            const average = (data[i] + data[i + 1] + data[i + 2]) / 3

            data[i] = average

            data[i + 1] = average

            data[i + 2] = average
          }

          ctx.putImageData(imgdata, 0, 0)

          cb(canvas.toDataURL('image/png'))
        }
      },

      setSealType(type) {
        this.ruleForm.sealType = type

        if (type !== 0) {
          this.ruleForm.surroundWord = null
        }
        this.ruleForm.siding = type === 4 ? '1.0mm' : '1.2mm'
      },
      setUploadSealType(type) {
        this.ruleForm.uploadSealType = type

        if (type !== 0) {
          this.ruleForm.surroundWord = null
        }

        this.ruleForm.siding = type === 4 ? '1.0mm' : '1.2mm'
      },

      getSealImg() {
        this.sealImg = this.createdSeat(2)
      },

      createdSeat(ratio = 1) {
        const {
          sealType,

          diametre,

          infoCode,
          centerWord,
          rankWord,

          surroundWord,
        } = this.ruleForm

        // 椭圆章
        if (sealType === 4) {
          // return FXQ.companyEllipse({
          //   companyName: surroundWord
          //     ? `${this.userInfo.comName}${surroundWord}`
          //     : this.userInfo.comName,
          //   text: centerWord ? centerWord.toString() : '',
          //   code: rankWord ? rankWord.toString() : '',
          //   cType: 0,
          //   fType: 0,
          // })

          return drawEllipseSeal({
            companyName: surroundWord
              ? `${this.companyName}${surroundWord}`
              : this.companyName,
            code: centerWord ? centerWord.toString() : '',
            text: rankWord ? rankWord.toString() : '',
            ratio,
          })
        }
        return makeSeal({
          radioFlag: sealType === 2 ? 0 : 1, // 是否绘制五角星

          sealWidth: this.sealWidth[diametre],

          code: infoCode,

          text: rankWord,

          companyName: surroundWord
            ? `${this.companyName}${surroundWord}`
            : this.companyName,

          sealHeight: this.sealWidth[diametre],
          ratio,
        })
      },

      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.saveData()
          } else {
            console.log('error submit!!')

            return false
          }
        })
      },

      resetForm(formName) {
        this.$refs[formName].resetFields()
      },

      handleDownloadSeal() {
        this.getSealImg()
        const a = document.createElement('a')
        a.download = 'seal.png'
        a.href = this.sealImg
        a.click()
      },
    },
  }
</script>

<style lang="less">
  .make-seal-wrap {
    margin: -28px 0;
    display: flex;
    justify-content: center;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 88px;
    .el-form .el-form-item .el-form-item__label {
      padding: 0;

      font-size: 12px;

      font-family: PingFangSC-Medium, PingFang SC;

      font-weight: 500;

      color: rgba(17, 26, 52, 1);

      text-align: left;
    }

    .el-radio__inner {
      width: 16px;

      height: 16px;
    }

    .el-radio__input.is-checked + .el-radio__label {
      font-size: 12px;

      font-family: PingFangSC-Medium, PingFang SC;

      font-weight: 500;

      color: rgba(17, 26, 52, 1);
    }

    .el-radio__label {
      font-size: 12px;

      font-family: PingFangSC-Medium, PingFang SC;

      font-weight: 500;

      color: rgba(17, 26, 52, 1);
    }
    .item-update {
      margin-left: 115px;
      margin-bottom: 24px;
      position: relative;
      .add-img {
        display: flex;

        .item-text {
          width: 477px;
          height: 120px;
          font-size: 12px;
          color: #8a9ab4;
          margin-left: 16px;
          line-height: 20px;
        }
        .profile-photo-frame {
          width: 190px;
          height: 190px;
          border: 1px solid #e2e4ea;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-upload {
            width: 100%;
            height: 100%;
            display: block;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .text {
              display: flex;
              align-items: center;
              flex-direction: column;
              font-size: 12px;
              span {
                color: #111a34;
              }

              img {
                margin-bottom: 14px;
              }
            }
          }
        }
      }
      .operation {
        height: 40px;
        background: #f2f2f2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 624px;
        padding: 0 16px;
        .left {
          width: 215px;
          font-size: 12px;
          color: #677283;
          display: flex;
          align-items: center;

          .slider {
            width: 123px;
            padding: 0 10px;
            .el-slider__runway {
              height: 3px;
            }
            .el-tooltip {
              width: 12px;
              height: 12px;
            }
          }
        }
        .middle {
          margin-left: 10px;
          margin-right: 24px;
          .btn {
            margin-left: 28px;
            img {
              width: 15px;
            }
          }
        }
        .right {
          display: flex;
          font-size: 12px;
          color: var(--main-color);
          .btn {
            margin-left: 24px;
          }
        }
      }
    }
    .item-update-status {
      display: flex;
      align-items: flex-end;

      .seal-img-box {
        width: 190px;
        height: 190px;
        border: 1px solid #e2e4ea;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        .seal-img {
          width: 136px;
          height: 136px;
        }
      }
      span {
        color: var(--main-color);
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
</style>

<style lang="less" scoped>
  .make-seal-wrap {
    background: #fff;
    height: 100%;
    box-sizing: border-box;
    .title {
      padding: 0 24px;
      position: sticky;
      background: #fff;
      top: 0;
      z-index: 101;
    }

    .inner {
      height: 100%;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);

      border-radius: 0px 6px 6px 6px;

      padding: 33px 0 32px 32px;
      .seal-style-list {
        display: flex;

        align-items: center;

        margin-left: -115px;

        .seal-style-item {
          margin-right: 40px;
          cursor: pointer;

          .img-wrap {
            display: flex;

            justify-content: center;

            align-items: center;

            width: 174px;

            height: 174px;

            border-radius: 4px;

            border: 1px solid rgba(109, 119, 144, 0.14);

            img {
              //width: 104px;

              height: 104px;
            }

            margin-bottom: 25px;
          }

          .select {
            border: 1px solid rgba(22, 187, 131, 1);
          }

          .radio-wrap {
            display: flex;

            justify-content: center;

            align-items: center;
          }
        }
      }

      .form-label {
        width: 68px;

        height: 25px;

        padding: 0 10px;

        background: url('../../assets/imgs/makeSealLabel.png') no-repeat center;

        background-size: 68px 25px;

        font-size: 12px;

        font-family: PingFangSC-Medium, PingFang SC;

        font-weight: 500;

        color: rgba(255, 255, 255, 1);

        line-height: 25px;

        text-align: center;

        margin-bottom: 24px;
      }

      .form-content {
        // width: 440px;

        // overflow: hidden;

        /deep/ .el-form-item__content {
          width: 320px;

          overflow: hidden;
        }
      }

      .seal-text {
        width: 320px;

        // overflow: hidden;

        /deep/ .el-input__inner {
          width: 320px;

          white-space: nowrap;

          overflow: hidden;

          text-overflow: ellipsis;
        }
      }

      .sealPrePosition {
        position: relative;

        .seal-preview {
          position: absolute;

          left: calc(364px + 145px);

          top: 36px;

          z-index: 100;

          .seal-pre-img {
            width: 340px;

            height: 340px;

            border: 1px dashed rgba(193, 196, 205, 1);

            padding: 16px;

            margin-bottom: 22px;

            .title {
              width: 48px;

              height: 20px;

              font-size: 12px;

              font-family: PingFangSC-Medium, PingFang SC;

              font-weight: 500;

              color: rgba(103, 114, 131, 1);

              line-height: 20px;

              margin-bottom: 24px;
            }

            .img-wrap {
              display: flex;

              justify-content: center;

              align-items: center;

              height: 240px;
            }

            img {
              width: 100%;
            }
            .example {
              width: 220px;
              height: 220px;
            }
          }
        }

        .btn {
          width: 64px;

          height: 28px;

          background: rgba(255, 255, 255, 1);

          border-radius: 16px;

          border: 1px solid var(--main-color);

          font-size: 12px;

          font-family: PingFangSC-Medium, PingFang SC;

          font-weight: 500;

          color: var(--main-color);

          line-height: 28px;

          text-align: center;

          margin: 0 auto;

          cursor: pointer;
        }
      }

      .people-list {
        display: flex;

        align-items: center;

        .people-item {
          margin-right: 16px;

          height: 32px;

          background: rgba(22, 118, 255, 0.1);

          border-radius: 16px;

          line-height: 32px;

          font-size: 12x;

          font-family: PingFangSC-Medium, PingFang SC;

          font-weight: 500;

          color: var(--main-color);

          display: flex;

          align-items: center;

          justify-content: center;

          padding: 0 10px;

          .name {
            min-width: 88px;
          }

          img {
            width: 12px;

            height: 12px;

            margin-left: 10px;

            cursor: pointer;
          }
        }

        .add {
          cursor: pointer;
        }
      }
    }

    /deep/ .operate-footer {
      z-index: 101;
      .operate-footer-container {
        justify-content: flex-end;
      }
    }

    .footer {
      display: flex;

      justify-content: center;

      align-items: center;

      margin-bottom: 26px;
    }
    .slice-img {
      width: 190px;
      height: 190px;
      position: absolute;
      right: 0;
      bottom: 0;
      opacity: 0;
      img {
        width: 165px;
        height: 165px;
      }
    }
  }
</style>
